import { Box, Typography } from "@material-ui/core";

const MedicalHistoryWeightHeightCard = ({ label, value, suffix = "", classes }) => {
    if (value === null || value === undefined) return null;

    return (
        <Box style={{ lineHeight: ".5" }}>
            <Typography className={`${classes.txtCardDescription} ${classes.txtFormWeightDescription}`}>
                {label}
            </Typography>
            <Typography className={`${classes.txtCardDescription} ${classes.txtFormWeightDescription}`}>
                {`${value}${suffix}`}
            </Typography>
        </Box>
    );
};

export default MedicalHistoryWeightHeightCard;
